import React, {CSSProperties, useEffect, useRef, useState} from "react";
import {toPng} from "html-to-image";
import {State, useTypedSelector, useWorkspaceSetting, useWorkspaceSettingsUpdate} from "../../store";
import {useDispatch} from "react-redux";
import {addOptimizationImgUrl, imgData, setOptimizationImgInProgress} from "../../store/optimization";

export const CacheDiv = ({children, style, cacheId, active, toggleSelector, ...props}: {
    children: React.ReactNode,
    style?: CSSProperties,
    cacheId: string,
    active: boolean,
    on?: boolean,
    toggleSelector: (state: State) => boolean,
    aura?: number
    resolution?: number
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const cache = useTypedSelector(state => state.optimization.imgURL[cacheId]);
    const inProgress = useTypedSelector(state => state.optimization.imgInProgress[cacheId]);
    useWorkspaceSetting("dark mode");
    const on = useTypedSelector(toggleSelector);
    const dispatch = useDispatch();

    let aura = props.aura ?? 0;
    let resolution = props.resolution ?? 1;

    useEffect(() => {
        if (active && !!ref.current) {
            if (!cache && !inProgress) {
                dispatch(setOptimizationImgInProgress(cacheId));

                let canvasWidth = ref.current.clientWidth * resolution;
                let canvasHeight = ref.current.clientHeight * resolution;

                toPng(ref.current, {cacheBust: true, canvasWidth, canvasHeight}).then(
                    dataUrl => {
                        dispatch(addOptimizationImgUrl(cacheId, dataUrl));
                    }
                );
            }
        }
    }, [active, ref]);

    let renderImg = cache && on && props.on;

    let pos: CSSProperties = {
        position: 'absolute',
        top: -aura,
        left: -aura
    }

    return renderImg ? <img src={imgData[cacheId]} style={{
        ...pos,
        width: "calc(100% + " + (aura * 2) + "px)",
        height: "calc(100% + " + (aura * 2) + "px)",
        ...style
    }} alt={"I'm a node!"}/> : <div style={{
        ...pos,
        width: "calc(100% + " + (aura * 2) + "px)",
        height: "calc(100% + " + (aura * 2) + "px)",
        ...style
    }}><div ref={ref} style={{position: "absolute", left: 0, top: 0, width: "100%", height: "100%"}}>
        <div style={{
            position: 'absolute',
            inset: aura
            /*left: a,
            top: a,
            width: "calc(100% - " + (a * 2) + "px)",
            height: "calc(100% - " + (a * 2) + "px)"*/
        }}>
            {children}
        </div>
    </div>
    </div>
}